import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Paper, Typography, Box, Button } from "@mui/material";

export default function NotFound() {
	const navigate = useNavigate();

	return (
		<Container maxWidth="sm">
			<Box
				sx={{
					minHeight: "100vh",
					display: "flex",
					alignItems: "center",
					justifyContent: "center",
				}}
			>
				<Paper elevation={3} sx={{ p: 4, width: "100%", textAlign: "center" }}>
					<Typography
						variant="h1"
						component="h1"
						sx={{ fontSize: "4rem", fontWeight: "bold", mb: 2 }}
					>
						404
					</Typography>
					<Typography variant="h5" gutterBottom>
						Page Not Found
					</Typography>
					<Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
						The page you're looking for doesn't exist or has been moved.
					</Typography>
					<Button
						variant="contained"
						onClick={() => navigate("/")}
						sx={{ mt: 2 }}
					>
						Go to Home
					</Button>
				</Paper>
			</Box>
		</Container>
	);
}
